export const categories = [
  {
    name: "Shoes",
    url: "https://kaspreadsheet.com/category-911-Shoes.html",
    description: "Sneakers, boots, and footwear finds",
    imageSeq: "cat-shoes-01",
  },
  {
    name: "Hoodies/Sweaters",
    url: "https://kaspreadsheet.com/search-912/name/Shoes.html",
    description: "Cozy streetwear essentials",
    imageSeq: "cat-hoodies-02",
  },
  {
    name: "T-Shirts",
    url: "https://kaspreadsheet.com/search-913/name/Shoes.html",
    description: "Graphic tees and basics",
    imageSeq: "cat-tshirts-03",
  },
  {
    name: "Jackets",
    url: "https://kaspreadsheet.com/search-914/name/Shoes.html",
    description: "Outerwear for every season",
    imageSeq: "cat-jackets-04",
  },
  {
    name: "Pants/Shorts",
    url: "https://kaspreadsheet.com/search-915/name/Shoes.html",
    description: "Bottoms from cargo to denim",
    imageSeq: "cat-pants-05",
  },
  {
    name: "Headwear",
    url: "https://kaspreadsheet.com/search-916/name/Shoes.html",
    description: "Caps, beanies, and more",
    imageSeq: "cat-headwear-06",
  },
  {
    name: "Sets",
    url: "https://kaspreadsheet.com/search-917/name/Shoes.html",
    description: "Coordinated outfit bundles",
    imageSeq: "cat-sets-07",
  },
  {
    name: "Underwear/Underpants",
    url: "https://kaspreadsheet.com/search-918/name/Shoes.html",
    description: "Comfort essentials collection",
    imageSeq: "cat-underwear-08",
  },
  {
    name: "Jersey",
    url: "https://kaspreadsheet.com/search-919/name/Shoes.html",
    description: "Sports and team jerseys",
    imageSeq: "cat-jersey-09",
  },
  {
    name: "Accessories",
    url: "https://kaspreadsheet.com/search-920/name/Shoes.html",
    description: "Watches, jewelry, and extras",
    imageSeq: "cat-accessories-10",
  },
  {
    name: "Bags",
    url: "https://kaspreadsheet.com/search-921/name/Shoes.html",
    description: "Backpacks, totes, and slings",
    imageSeq: "cat-bags-11",
  },
  {
    name: "Belts",
    url: "https://kaspreadsheet.com/search-922/name/Shoes.html",
    description: "Leather and canvas belts",
    imageSeq: "cat-belts-12",
  },
  {
    name: "Perfumes",
    url: "https://kaspreadsheet.com/search-923/name/Shoes.html",
    description: "Fragrances and scents",
    imageSeq: "cat-perfumes-13",
  },
  {
    name: "Other Stuff",
    url: "https://kaspreadsheet.com/search-924/name/Shoes.html",
    description: "Everything else worth finding",
    imageSeq: "cat-other-14",
  },
];

export const categoryThumbnails: Record<string, string> = {
  "cat-shoes-01":
    "https://readdy.ai/api/search-image?query=Single%20pair%20of%20vibrant%20coral%20red%20athletic%20sneakers%20with%20white%20sole%20placed%20diagonally%20on%20cool%20gray%20concrete%20surface%20dramatic%20hard%20side%20lighting%20from%20left%20casting%20bold%20angular%20shadow%20urban%20industrial%20product%20photography%20high%20contrast%20saturated%20colors%20sharp%20detail&width=200&height=200&seq=thumb-shoes-v2-01&orientation=squarish",
  "cat-hoodies-02":
    "https://readdy.ai/api/search-image?query=Rich%20mustard%20yellow%20oversized%20cotton%20hoodie%20folded%20flat%20on%20soft%20lavender%20purple%20linen%20fabric%20warm%20golden%20hour%20sunlight%20streaming%20from%20window%20cheerful%20editorial%20fashion%20photography%20playful%20color%20contrast%20soft%20shadows&width=200&height=200&seq=thumb-hoodies-v2-02&orientation=squarish",
  "cat-tshirts-03":
    "https://readdy.ai/api/search-image?query=Vibrant%20coral%20pink%20graphic%20printed%20cotton%20tshirt%20with%20retro%20typography%20neatly%20folded%20on%20bright%20white%20marble%20surface%20with%20tiny%20green%20succulent%20plant%20beside%20it%20fresh%20clean%20modern%20product%20photography%20spring%20morning%20aesthetic%20crisp%20details&width=200&height=200&seq=thumb-tshirts-v2-03&orientation=squarish",
  "cat-jackets-04":
    "https://readdy.ai/api/search-image?query=Classic%20faded%20indigo%20denim%20trucker%20jacket%20with%20warm%20copper%20tone%20buttons%20hanging%20on%20weathered%20rustic%20wooden%20plank%20wall%20with%20delicate%20green%20ivy%20vine%20trailing%20alongside%20soft%20natural%20window%20light%20editorial%20fashion%20photography%20earthy%20organic%20textures&width=200&height=200&seq=thumb-jackets-v2-04&orientation=squarish",
  "cat-pants-05":
    "https://readdy.ai/api/search-image?query=Olive%20military%20green%20relaxed%20cargo%20trousers%20and%20natural%20beige%20linen%20shorts%20laid%20flat%20side%20by%20side%20on%20warm%20terracotta%20orange%20textured%20ceramic%20surface%20bright%20Mediterranean%20sunlight%20casting%20soft%20crisp%20shadows%20resort%20lifestyle%20aesthetic%20clean%20composition&width=200&height=200&seq=thumb-pants-v2-05&orientation=squarish",
  "cat-headwear-06":
    "https://readdy.ai/api/search-image?query=Soft%20pastel%20mint%20green%20cotton%20baseball%20cap%20next%20to%20natural%20woven%20straw%20wide%20brim%20sun%20hat%20placed%20on%20warm%20sandy%20beige%20textured%20surface%20with%20hazy%20ocean%20horizon%20blurred%20in%20distant%20background%20bright%20summer%20day%20vacation%20mood%20relaxed%20aesthetic&width=200&height=200&seq=thumb-headwear-v2-06&orientation=squarish",
  "cat-sets-07":
    "https://readdy.ai/api/search-image?query=Elegant%20dusty%20rose%20pink%20coordinated%20loungewear%20tracksuit%20set%20draped%20gracefully%20over%20plush%20velvet%20upholstered%20armchair%20in%20softly%20candlelit%20intimate%20room%20romantic%20editorial%20fashion%20photography%20luxurious%20feminine%20aesthetic%20gentle%20warm%20glow&width=200&height=200&seq=thumb-sets-v2-07&orientation=squarish",
  "cat-underwear-08":
    "https://readdy.ai/api/search-image?query=Soft%20sky%20blue%20organic%20cotton%20boxer%20briefs%20and%20crisp%20white%20cotton%20tank%20top%20arranged%20on%20light%20natural%20birch%20wood%20surface%20with%20fresh%20eucalyptus%20leaf%20sprig%20beside%20them%20clean%20spa%20like%20product%20photography%20serene%20wellness%20aesthetic%20morning%20light%20zen%20composition&width=200&height=200&seq=thumb-underwear-v2-08&orientation=squarish",
  "cat-jersey-09":
    "https://readdy.ai/api/search-image?query=Bold%20crimson%20red%20and%20white%20striped%20athletic%20sports%20jersey%20with%20metallic%20gold%20number%20detail%20spread%20flat%20on%20vibrant%20fresh%20green%20artificial%20grass%20turf%20under%20bright%20stadium%20floodlights%20energetic%20sports%20editorial%20photography%20dynamic%20diagonal%20composition%20action%20mood&width=200&height=200&seq=thumb-jersey-v2-09&orientation=squarish",
  "cat-accessories-10":
    "https://readdy.ai/api/search-image?query=Elegant%20rose%20gold%20tone%20minimalist%20wristwatch%20with%20genuine%20tan%20leather%20strap%20displayed%20on%20deep%20navy%20blue%20velvet%20fabric%20surface%20with%20scattered%20iridescent%20pearl%20beads%20around%20it%20luxury%20jewelry%20boutique%20product%20photography%20sophisticated%20dark%20mood%20refined%20details&width=200&height=200&seq=thumb-accessories-v2-10&orientation=squarish",
  "cat-bags-11":
    "https://readdy.ai/api/search-image?query=Rich%20cognac%20brown%20genuine%20leather%20vintage%20style%20backpack%20with%20polished%20brass%20tone%20hardware%20placed%20on%20light%20oak%20wooden%20bench%20inside%20cozy%20bookshop%20interior%20with%20warm%20tungsten%20ambient%20lighting%20vintage%20academic%20aesthetic%20old%20world%20charm%20cozy%20atmosphere&width=200&height=200&seq=thumb-bags-v2-11&orientation=squarish",
  "cat-belts-12":
    "https://readdy.ai/api/search-image?query=Handwoven%20multicolored%20bohemian%20style%20fabric%20belt%20with%20intricate%20geometric%20patterns%20coiled%20elegantly%20on%20sun%20bleached%20natural%20driftwood%20piece%20at%20tropical%20beach%20shore%20during%20golden%20sunset%20hour%20travel%20lifestyle%20editorial%20photography%20warm%20breezy%20atmosphere%20paradise%20mood&width=200&height=200&seq=thumb-belts-v2-12&orientation=squarish",
  "cat-perfumes-13":
    "https://readdy.ai/api/search-image?query=Crystal%20clear%20faceted%20glass%20luxury%20perfume%20bottle%20filled%20with%20warm%20amber%20gold%20liquid%20surrounded%20by%20fresh%20white%20orange%20blossoms%20on%20deep%20espresso%20brown%20silk%20fabric%20surface%20dramatic%20directional%20spotlight%20product%20photography%20opulent%20fragrance%20boutique%20aesthetic%20rich%20contrast&width=200&height=200&seq=thumb-perfumes-v2-13&orientation=squarish",
  "cat-other-14":
    "https://readdy.ai/api/search-image?query=Playful%20eclectic%20assortment%20of%20colorful%20glossy%20enamel%20pins%20retro%20cat%20eye%20sunglasses%20and%20embroidered%20whimsical%20patches%20scattered%20organically%20on%20bright%20turquoise%20blue%20painted%20weathered%20wood%20surface%20fun%20maximalist%20lifestyle%20product%20photography%20pop%20art%20aesthetic%20vibrant%20energy&width=200&height=200&seq=thumb-other-v2-14&orientation=squarish",
};